import { OrganizationSummaryStore } from 'src/stores/organizations-store';

export default class PartnerInfo {
  private loadAccessibleOrgs = async () => {
    try {
      const items = await this._orgStore.getAll();
      this._accessibleOrgs = items.map((x) => x.id);
    } catch {
      this._accessibleOrgs = [];
    }
  };
  private _organizationId: string;
  private _orgStore: OrganizationSummaryStore;
  private _accessibleOrgs: string[];

  constructor(orgStore: OrganizationSummaryStore) {
    this._organizationId = 'INVALID_VALUE';
    this._orgStore = orgStore;
    this._accessibleOrgs = [];
  }

  public set organizationId(orgId: string) {
    this._organizationId = orgId;
    this.loadAccessibleOrgs();
  }

  public get organizationId() {
    return this._organizationId;
  }

  public get accessibleOrgs() {
    return this._accessibleOrgs;
  }
}
